import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {delay} from 'lodash';

import {commentsCount, submitFeedback} from '../actions';

import Success from '../components/Success';

class Feedback extends Component {
  constructor(props) {
    super(props);

    this.state = {
      success: false,
      feedback: null, // yes, no, other
      otherContent: null,
    };
  }

  static defaultProps = {
    onCancel: () => {},
    onChange: e => {},
    onSubmit: () => {},
  };

  setFeedback = e => {
    this.setState({feedback: e.target.value, otherContent: null});
  };

  resetForm = () => {
    this.setState({feedback: null, otherContent: null, success: false});
    this.props.onCancel();
  };

  onChange = e => {
    this.props.onChange(e.target.value);
    this.setState({otherContent: e.target.value});
  };

  get payload() {
    let content =
      this.state.feedback === 'other'
        ? this.state.otherContent
        : this.state.feedback;

    return {
      kind: this.props.type,
      content: content,
    };
  }

  renderOtherContent = () => {
    if (this.state.feedback !== 'other') return;

    return (
      <section className="cardSection --micro _noPaddingTop">
        <label className="ds-input _noBottomMargin">
          <span>How can we improve your experience?</span>
          <textarea
            placeholder="Type your message here"
            onChange={this.onChange}>
            {this.state.otherContent}
          </textarea>
        </label>
      </section>
    );
  };

  renderSendButton = () => {
    if (this.state.feedback === null) return;

    return (
      <Fragment>
        {this.renderOtherContent()}
        <section className="cardSection _footer --micro _noPaddingTop">
          <button
            className="ds-btn --micro _link -secondary"
            data-testid="feedback-cancel-button"
            onClick={this.resetForm}>
            Cancel
          </button>
          <button
            className="ds-btn --micro -secondary _right"
            data-testid="feedback-submit-button"
            onClick={this.onClick}>
            Send Feedback
          </button>
        </section>
      </Fragment>
    );
  };

  onClick = () => {
    this.props.onSubmit();
    this.props.submitFeedback(this.payload, () => {
      this.setState({success: true});

      delay(() => {
        this.props.commentsCount();
      }, 1000);
    });
  };

  render() {
    if (this.props.feedbacks[this.props.type] > 0) return <div />;
    if (this.state.success) return <Success />;

    return (
      <div className="ds-card _addTopMargin">
        <section className="cardSection _withColumns">
          <div className="text">
            <p className="copy">Is this page helpful for you?</p>
          </div>

          <div className="ds-buttonGroup _spacedButtons">
            <div className="ds-radio _marginRight--xsmall">
              <input
                type="radio"
                name="feedback"
                id="radio-one"
                checked={this.state.feedback === 'yes'}
                value="yes"
                onChange={e => {
                  this.setFeedback(e);
                }}
                data-testid="feedback-yes-radio"
                onClick={this.props.onClickFeedbackItem}
              />
              <label className="ds-btn" for="radio-one">
                Yes
              </label>
            </div>
            <div className="ds-radio _marginRight--xsmall">
              <input
                type="radio"
                name="feedback"
                id="radio-two"
                checked={this.state.feedback === 'no'}
                value="no"
                onChange={e => {
                  this.setFeedback(e);
                }}
                data-testid="feedback-no-radio"
                onClick={this.props.onClickFeedbackItem}
              />
              <label className="ds-btn" for="radio-two">
                No
              </label>
            </div>
            <div className="ds-radio">
              <input
                type="radio"
                name="feedback"
                id="radio-three"
                checked={this.state.feedback === 'other'}
                value="other"
                onChange={e => {
                  this.setFeedback(e);
                }}
                data-testid="feedback-other-radio"
                onClick={this.props.onClickFeedbackItem}
              />
              <label className="ds-btn" for="radio-three">
                Other
              </label>
            </div>
          </div>
        </section>
        {this.renderSendButton()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    feedbacks: state.feedbacks,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    submitFeedback: (body, onSuccess) => {
      dispatch(submitFeedback(body, onSuccess));
    },
    commentsCount: () => {
      dispatch(commentsCount(props.type));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Feedback);



// WEBPACK FOOTER //
// ./src/features/feedbacks/containers/Feedback.js